import axios from "axios";
import React, { useEffect, useState } from "react";

import Card from "./Card";

const Form = () => {
  const [moviesData, setMoviesData] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [sortGoodBad, setSortGoodBad] = useState(null);
  const [ifPages, setIfPages] = useState(false);

  const API_KEY = process.env.REACT_APP_API_KEY;

  console.log("-----------------moviesData-------------------");
  console.log(moviesData);
  console.log("------------------------------------");

  useEffect(() => {
    axios
      .get(`https://api.themoviedb.org/3/search/movie?api_key=${API_KEY}&query=${search}&language=fr-FR`)

      .then((res) => {
        console.log("---------------res.data.results---------------------");
        console.log(res.data.results);
        console.log("------------------------------------");
        console.log("-----------------res.data.total_pages-------------------");
        console.log(res.data.total_pages);
        console.log("------------------------------------");
        setMoviesData(res.data.results);
        if (res.data.total_pages > 1) {
          setIfPages(true);
        }
      });
  }, [search, API_KEY]);

  const nextPage = () => {
    setPage(page + 1);

    axios
      .get(
        `https://api.themoviedb.org/3/search/movie?api_key=${API_KEY}&query=${search}&language=fr-FR&page=${page + 1}`
      )
      .then((res) => setMoviesData([...moviesData, ...res.data.results]));
  };

  return (
    <div className="form-component">
      <div className="form-container">
        <form>
          <input type="text" placeholder="Rechercher" id="search-input" onChange={(e) => setSearch(e.target.value)} />
          <input type="submit" value="Supprimer" />
        </form>

        <div className="btn-sort-container">
          <div className="btn-sort" id="goodToBad" onClick={() => setSortGoodBad("goodToBad")}>
            Top<span>➞</span>
          </div>
          <div className="btn-sort" id="badToGood" onClick={() => setSortGoodBad("badToGood")}>
            Flop<span>➞</span>
          </div>
        </div>
      </div>
      <div className="result">
        {moviesData
          //.slice(0, 12)
          .sort((a, b) => {
            if (sortGoodBad === "goodToBad") {
              return b.vote_average - a.vote_average;
            } else if (sortGoodBad === "badToGood") {
              return a.vote_average - b.vote_average;
            }
          })
          .map((movie) => {
            /*
            console.log("===============movie=====================");
            console.log(movie.id);
            console.log("====================================");*/
            return <Card key={movie.id} movie={movie} />;
          })}
      </div>
      {ifPages ? (
        <div className="btn-next" onClick={nextPage}>
          <span>Suivant</span>
          <span>⬇️</span>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Form;
